/**
 * Platform adapter — installs the web adapter as window.electron.
 * Must be called BEFORE any code accesses window.electron.
 */

import { createWebAdapter } from './webAdapter';

export { isWebMode } from './types';

export function installPlatformShim(): void {
  console.log('[Platform] Running in Web mode, installing adapter...');
  (window as any).electron = createWebAdapter();
  console.log('[Platform] Web adapter installed');
}
